import { createApi } from '@reduxjs/toolkit/query/react';

import {
  fetchWithAuthBaseQuery,
  validateAndTransformResponse,
} from '#shared/api';
import type { DataWithValidation } from '#shared/api';

import { asGeoLibraryResult } from './geoLibraryPayload';
import { geoLibraryResponseSchema } from './schemas';

import type { CCGeoLibrary } from '../model';

const paths = {
  geoLibrary: 'api/geoLibrary',
} as const;

export const geoLibraryApi = createApi({
  reducerPath: 'geoLibraryApi',

  baseQuery: fetchWithAuthBaseQuery,
  refetchOnReconnect: true,
  endpoints: build => ({
    getGeoLibrary: build.query<DataWithValidation<CCGeoLibrary>, void>({
      query: () => paths.geoLibrary,
      // The BE passes NOP's payload through unwrapped, so `asGeoLibraryResult`
      // is what puts it on the envelope the validator expects.
      transformResponse: (response: unknown) =>
        validateAndTransformResponse(
          geoLibraryResponseSchema,
          asGeoLibraryResult(response),
          value => value?.serviceRegions?.[0]?.name,
          'geoLibrary',
        ),
    }),
  }),
});

export const { useGetGeoLibraryQuery } = geoLibraryApi;
